import React from 'react';
import ContentLoader from 'react-content-loader';

const FakeColumn: React.FC = () => (
  <ContentLoader
    speed={2}
    width="100%"
    height={20}
    backgroundColor="#f3f3f3"
    foregroundColor="#ecebeb"
  >
    <rect x="0" width="100%" rx="0" ry="0" height="40" />
  </ContentLoader>
);

export default FakeColumn;
